import { i18nTranslationHelper } from '@/i18n'
import PathConstants from '../path-contants'

const getInternalCompanyManagerPaths = (): PathConstants.RoutesProps => {
  const t = i18nTranslationHelper.getTPage

  return {
    INTERNAL_COMPANY_MANAGER_USER_BATCH_DISABLE: {
      value: '/backoffice/user/batch-disable',
      name: 'internal_company_manager_user_batch_disable',
      title: t('internalCompanyManager.userBatchDisable.pageTitle')
    },
    INTERNAL_COMPANY_MANAGER_INVOICE_DETAIL: {
      value: '/backoffice/invoice/:id',
      name: 'internal_company_manager_invoice_detail',
      title: t('internalCompanyManager.invoiceDetail.pageTitle'),
      computeValue: args => `/backoffice/invoice/${args.id}`
    },
    INTERNAL_COMPANY_MANAGER_INVOICE: {
      value: '/backoffice/invoice',
      name: 'internal_company_manager_invoice',
      title: t('internalCompanyManager.invoice.pageTitle')
    },
    INTERNAL_COMPANY_MANAGER_COMPANY_DETAIL: {
      value: '/backoffice/company/:id',
      name: 'internal_company_manager_company_detail',
      title: t('internalCompanyManager.companyDetail.pageTitle'),
      computeValue: args => `/backoffice/company/${args.id}`
    },
    INTERNAL_COMPANY_MANAGER_PARTNER_DETAIL: {
      value: '/backoffice/partner/:id',
      name: 'internal_company_manager_partner_detail',
      title: t('internalCompanyManager.partnerDetail.pageTitle'),
      computeValue: args => `/backoffice/partner/${args.id}`
    }
  }
}

export default getInternalCompanyManagerPaths
